import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import SEConfirmModal from "../components/common/SEConfirmModal";
import { activeTabAtom } from "../utils/atoms/activeTabAtom";
import { useAtom } from "jotai";

export const formatInputValue = (inputValue) => {
  inputValue = inputValue.replace(/^0+(?!$)/, "");
  if (inputValue.startsWith(".")) {
    inputValue = "0" + inputValue;
  }
  return inputValue;
};

export const mgaRegex = {
  oneToHundredRegex: /^(\d{0,2}|100)$/,
  oneTo25Regex: /^([1-9]|1[0-9]|2[0-5])$/,
  zeroToThreeHundred: /^(0|[1-9]?\d|1\d{2}|2\d{2}|300)$/,
  zeroToNine99Regex: /^(0|[1-9]\d{0,4})$/,
  zeroToOneWithDecimal: /^(0(\.\d{1,5})?|1(\.0{1,5})?)$/,
  zeroTo1000WithDecimal:
    /^(0(\.\d{1,2})?|[1-9]\d{0,2}(\.\d{1,2})?|1000(\.0{1,2})?)$/,
  zeroTO200WithDecimal:
    /^(0(\.\d{1,2})?|[1-9]\d{0,1}(\.\d{1,2})?|1\d{2}(\.\d{1,2})?|200(\.0{1,2})?)$/,
  zeroToHundredWithDecimal: /^(100(?:\.0{1,2})?|(?:\d{1,2})(?:\.\d{1,2})?)$/,
  zeroToNinetyNineWithSingleOrDoubleDecimal:/^(?:0(?:\.[0-9]{1,2})?|(?:[1-9][0-8]?)(?:\.[0-9]{1,2})?|99(?:\.0{1,2})?)$/,
  zeroToNinetyNineWithDecimal:/^(?:99(?:\.0{1,2})?|(?:[0-9]|[1-9][0-8])(?:\.\d{1,2})?)$/,
  zeroToHundredWithMaxFiveDecimal:
    /^(?:100(?:\.0{1,5})?|(?:\d{1,2})(?:\.\d{1,5})?)$/,
  zeroToThreeHundredWithDecimal:
    /^(300(\.00?)?|[1-2]?\d{1,2}(\.\d{1,2})?|0(\.0{1,2})?|\.0{1,2})$/,
  oneToLakhRegex: /^([1-9]\d{0,4}|100000)$/,
  oneToLakhWithDecimalRegex:
    /^(?:100000(?:\.0{1,4})?|(?:[1-9]\d{0,4})(?:\.\d{1,4})?)$/,
  zeroToMillionRegex: /^(\d{0,6}|1000000)$/,
  zeroToMillionRegexWithDecimal: /^(?:0|[1-9]\d{0,5}|1000000)(?:\.\d{1,2})?$/,
  zeroToMillionWithDecimalRegex:
    /^(1000000(?:\.0{1,2})?|(?:\d{1,6})(?:\.\d{1,2})?)$/,
  oneToTenThousandRegex: /^[1-9]\d{0,3}$/,
  oneToTenPower9Regex: /^(?:[1-9]\d{0,8}|1000000000)$/,
  zeroToTenPower9WithDecimalRegex:/^(?:1000000000(?:\.00?)?|\d{1,9}(?:\.\d{1,2})?|0(?:\.\d{1,2})?)$/,
  minusNinetyNineToPlusNinetyNineRegex:
    /^(?:0|[1-9]\d{0,1}|[1-9]\d{2}|\+[1-9]\d{0,2}|-[1-9]\d?)$/,
  minusNinetyNineToPlusNinetyNineRegexWithDecimal:
    /^(?:-(?:[0-9](?:\.[0-9]{1,2})?|[1-8][0-9](?:\.[0-9]{1,2})?|9[0-8](?:\.[0-9]{1,2})?|99(?:\.0{1,2})?)|(?:0(?:\.[0-9]{1,2})?|[1-9][0-9]?(?:\.[0-9]{1,2})?|(?:[1-8][0-9]{2}|9[0-8][0-9]|99[0-8])(?:\.[0-9]{1,2})?|999(?:\.0{1,2})?))$/,
  zeroToThousandWithDecimal: /^(1000(?:\.0{1,2})?|(?:\d{1,3})(?:\.\d{1,2})?)$/,
  oneToNinetyNineThousandWithDecimal:
    /^(?:(?:[1-9]\d{0,3}|[1-8]\d{4}|9[0-8]\d{3})(?:\.\d{1,2})?|99000(?:\.0{1,2})?)$/,
  ZeroPointOneTo9999WithDecimal:
    /^(?:0\.(?:1\d?|[2-9]\d?)|[1-9]\d{0,3}(?:\.\d{1,2})?|9999(?:\.0{1,2})?)$/,
  positiveNumberWithdecimal: /^\d+(\.\d{1,2})?$/,
  zeroPointOneTO10Power9WithDecimal:/^(?:0\.(?:[1-9]\d?)|[1-9]\d{0,8}(?:\.\d{1,2})?|1000000000(?:\.0{1,2})?)$/,
  ZeroPointOneTo99999WithDecimal:
    /^(?:0\.[1-9]\d?|[1-9]\d{0,3}(?:\.\d{1,2})?|99999(?:\.0{1,2})?)$/,
  ZeroPointOneTO99999WithSingleDoubleDecimal:
    /^(?!99999\.(?:0?[1-9]|[1-9]\d?))(?:0\.(?:1\d?|[2-9]\d?)|[1-9]\d{0,4}(?:\.\d{1,2})?|99999(?:\.0{1,2})?)$/,
  FiftyToHundred:
    /^(?:5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9])(\.[0-9])?$|^100(\.0)?$/,
  ZeroToTwentyWithDecimal: /^(?:0|1?\d)(\.\d)?$|^20(\.0)?$/,
  NegativeNinetyToPositiveNinetyWithOneDecimal:
    /^([+-]?([0-8]?\d)(\.\d)?|[+-]?90(\.0)?)$/,
  ZeroToNinetyWithOneDecimal: /^(?:[0-8]?\d(?:\.\d{1,2})?|90(?:\.0{1,2})?)$/,
  onlyDigitsAndDecimal: /^(\d+(\.\d+)?|\.\d+)$/,
  oneToHundredWithoutDecimal: /^(100|[1-9][0-9]?)$/,
  zeroToThreeSixtyWithDecimal:/^(?:360(?:\.0)?|(?:3[0-5][0-9]|[12][0-9]{2}|[1-9]?[0-9])(?:\.[0-9])?)$/,
  leadingTrailingInternalSpacesRegex:/^\S+(\s\S+)*$/,
  phoneNumberRegex: /^(?=(?:\D*\d){7,15}\D*$)[+0-9\s-]+$/,
  namePattern: /^[a-zA-Z0-9_&\s-]*$/,
};

/**
 * Safely extract the last contiguous digit sequence from a string.
 * Uses `String.prototype.match` with a simple `\d+` global regex and
 * returns the final match. This avoids complex lookaheads that may
 * exhibit super-linear backtracking on malicious input.
 */
export const getTrailingNumber = (value) => {
  if (value === null || value === undefined) return null;
  const s = String(value);
  const matches = s.match(/\d+/g);
  return matches && matches.length ? matches[matches.length - 1] : null;
};

export const RawBusinessTypeList = {
  businessTypeList: [
    "End User",
    "Contractor",
    "Original Equipment Manufacturers",
    "Panel Builder",
    "Consumer Retailer",
    "Electrician",
    "System Integrator",
    "Specifier",
    "IT Reseller",
    "B2B Distribution",
    "Digital & Service Partner",
    "Internal Schneider Entity",
  ],
};

export const normalizeSpaces = (val = "") => val.replace(/ +(?= )/g, "");

export const convertPictureToBlobUrl = (picture) => {
  if (!picture) return "";
  if (typeof picture === "string") {
    if (picture.startsWith("data:") || picture.startsWith("http")) return picture;
    try {
      atob(picture);
      return `data:image/jpeg;base64,${picture}`;
    } catch {
      return picture;
    }
  }
  return "";
};

export const dataUriToFile = (dataUri, fileName = "picture") => {
  const separatorIndex = dataUri.indexOf(",");
  if (separatorIndex === -1) return null;
  const header = dataUri.slice(0, separatorIndex);
  const base64 = dataUri.slice(separatorIndex + 1);
  const mimeMatch = header.match(/data:([^;]+);base64/);
  if (!mimeMatch) return null;
  const mime = mimeMatch[1];
  const ext = mime.split("/")[1];
  try {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new File([bytes], `${fileName}.${ext}`, { type: mime });
  } catch {
    return null;
  }
};

const ALLOWED_PICTURE_TYPES = ["image/png", "image/jpeg", "image/jpg"];
const MAX_PICTURE_SIZE_BYTES = 1 * 1024 * 1024; // 1 MB

export const validateProfilePicture = (file) => {
  if (!ALLOWED_PICTURE_TYPES.includes(file.type)) {
    return "Only PNG, JPG, or JPEG images are allowed.";
  }
  if (file.size > MAX_PICTURE_SIZE_BYTES) {
    return "Image size must not exceed 1 MB.";
  }
  return null;
};

/**
 * Safely remove trailing '0' characters from a string without using regex.
 * Returns the input converted to string with trailing zeros removed.
 * If the input consists only of zeros, returns an empty string.
 */
export const trimTrailingZeros = (value) => {
  if (value === null || value === undefined) return "";
  const s = String(value);
  let i = s.length;
  while (i > 0 && s.charAt(i - 1) === "0") i--;
  return s.slice(0, i);
};

/**
 * Safe check for presence of an HTML-like tag in a string without using a backtrack-prone regex.
 * Returns true if a '<' appears before a '>' and the tag length is within a reasonable bound.
 */
export const isHtmlTag = (value, maxTagLength = 1000) => {
  if (!value || typeof value !== "string") return false;
  const lt = value.indexOf("<");
  if (lt === -1) return false;
  const gt = value.indexOf(">", lt + 1);
  if (gt === -1) return false;
  return gt - lt - 1 <= maxTagLength;
};

// Helper: treat numeric 0 or string "0" as valid — only null/undefined/empty/whitespace are blank
export const isNullOrWhitespace = (value) =>
  value === "" || value === undefined || value === null ||
  (typeof value === "string" && value.trim() === "");

export const isBlank = isNullOrWhitespace;

export const enumMapGrid = {
  FIXEDORONMAXPOWER: "FIXEDORONMAXPOWER",
  SUBSCRIBEDDEMAND: "SUBSCRIBEDDEMAND",
  RATCHET: "RATCHET",
  TOUANDTIER: "TOUANDTIER",
};

export const capitalizeFirstLetterAndSplitName = (name) => {
  return name
    ?.replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
};

/**
 * React hook to extract projectId, designId, and designVersionId from route params using useParams.
 * Usage: const { projectId, designId, designVersionId } = useAssessmentRouteParams();
 */
export function useAssessmentRouteParams() {
  const { projectId, designId, designVersionId } = useParams();
  return { projectId, designId, designVersionId };
}

/**
 * Given designComponentsList, designId, and designVersionId,
 * returns { componentDTOList, countComponentDTOList, usedDesignId, usedDesignVersionId } for the matching design and version.
 * If not found, returns the first available design/version if present.
 * Optionally calls onFallback(designId, designVersionId) if fallback is used.
 */
export function getDesignComponentLists(
  designComponentsList,
  designId,
  designVersionId,
  onFallback
) {
  if (!Array.isArray(designComponentsList) || designComponentsList.length === 0)
    return null;
  let design = designComponentsList.find(
    (d) => String(d.designId) === String(designId)
  );
  let version;
  if (design && Array.isArray(design.designVersionComponents)) {
    version = design.designVersionComponents.find(
      (v) => String(v.designVersionId) === String(designVersionId)
    );
  }
  if (!design || !version) {
    // fallback to first available
    design = designComponentsList[0];
    version = design?.designVersionComponents?.[0];
    if (onFallback && design && version)
      onFallback(design.designId, version.designVersionId);
    if (!design || !version) return null;
  }
  const countList = version.countComponentDTOList || [];
  const hasGrid = countList.some((c) => c.componentType === "Grid");
  const hasController = countList.some((c) => c.componentType === "Controller");
  const allowSimulation = hasGrid && hasController;
  return {
    componentDTOList: version.componentDTOList || [],
    countComponentDTOList: countList,
    usedDesignId: design.designId,
    usedDesignVersionId: version.designVersionId,
    allowSimulation,
  };
}

/**
 * React hook to get componentDTOList and countComponentDTOList for the current route.
 * If designId or designVersionId is missing, shows snackbar and redirects to the first available design/version.
 * Usage: const { componentDTOList, countComponentDTOList } = useCurrentDesignComponentLists(designComponentsList, showSnackBarFn);
 * showSnackBarFn: (msg) => void
 */
export function useCurrentDesignComponentLists(
  designComponentsList,
  showSnackBar
) {
  // Deprecated: Use useDesignComponentFallbackModal for modal-based fallback
  const { projectId, designId, designVersionId } = useAssessmentRouteParams();
  const navigate = useNavigate();
  let didFallback = false;
  let fallbackDesignId, fallbackDesignVersionId;
  const result = getDesignComponentLists(
    designComponentsList,
    designId,
    designVersionId,
    (fallbackId, fallbackVersionId) => {
      didFallback = true;
      fallbackDesignId = fallbackId;
      fallbackDesignVersionId = fallbackVersionId;
    }
  ) || { componentDTOList: [], countComponentDTOList: [] };
  useEffect(() => {
    if (didFallback && fallbackDesignId && fallbackDesignVersionId) {
      if (showSnackBar)
        showSnackBar(
          "Invalid design or version. Redirecting to available design."
        );
      navigate(
        `/assessment/${
          projectId || ""
        }/${fallbackDesignId}/${fallbackDesignVersionId}?tab=design`
      );
    }
    // eslint-disable-next-line
  }, [
    didFallback,
    fallbackDesignId,
    fallbackDesignVersionId,
    projectId,
    navigate,
    showSnackBar,
  ]);
  return result;
}

export const daysAgo = (isoDate) => {
  if (!isoDate) return "";
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return "";
  const diffMs = Date.now() - d.getTime();
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (days <= 0) return "today";
  if (days === 1) return "1 day ago";
  return `${days} days ago`;
};

export const statusToOpenClosed = (status) => {
  if (!status) return { label: "Open", color: "green" };
  const s = String(status).toLowerCase();
  if (s === "submitted" || s === "open") return { label: "Open", color: "green" };
  if (s === "in_progress") return { label: "In progress", color: "blue" };
  return { label: "Closed", color: "gray" };
};

export const getInitials = (value) => {
  if (!value) return "?";
  const v = String(value);
  const parts = v.split(/[\s@._-]+/).filter(Boolean);
  const a = parts[0]?.[0] || "?";
  const b = parts[1]?.[0] || "";
  return (a + b).toUpperCase();
};

export const downloadBase64File = (base64, contentType, fileName) => {
  if (!base64) return;

  try {
    const byteArray = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    const blob = new Blob([byteArray], { type: contentType || "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 500);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("Failed to download attachment", err);
  }
};

export const normalizeTicketEnvelope = (ticketData) => {
  if (!ticketData) return null;

  const envelope = typeof ticketData === "object" ? ticketData : {};
  const coreTicket = typeof envelope.ticket === "object" ? envelope.ticket : envelope;
  const commentsSource = Array.isArray(envelope.comments)
    ? envelope.comments
    : Array.isArray(coreTicket.comments)
      ? coreTicket.comments
      : [];

  return {
    ...coreTicket,
    ...envelope,
    comments: commentsSource.slice(),
  };
};

export const getApiErrorMessage = (err, fallback) => (
  err?.response?.data?.message
  || err?.response?.data?.error
  || err?.message
  || fallback
);

/**
 * Generic hook to handle design/version fallback with modal confirmation and redirect.
 * Usage:
 *   const { componentDTOList, countComponentDTOList, modal, showModal } = useDesignComponentFallbackModal({
 *     designComponentsList, designId, designVersionId, projectId, redirectBase, fallbackMessage
 *   });
 *   // Render {modal} in your component JSX
 */
export function useDesignComponentFallbackModal({
  designComponentsList,
  designId,
  designVersionId,
  projectId,
  redirectBase = "/assessment",
  fallbackMessage = "Invalid design or version. Redirecting to available design.",
  modalHeader = "Error",
}) {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [fallbackTarget, setFallbackTarget] = useState(null);
  const [result, setResult] = useState({
    componentDTOList: [],
    countComponentDTOList: [],
  });

  useEffect(() => {
    let didFallback = false;
    let fallbackDesignId, fallbackDesignVersionId;
    const res = getDesignComponentLists(
      designComponentsList,
      designId,
      designVersionId,
      (fbId, fbVersionId) => {
        didFallback = true;
        fallbackDesignId = fbId;
        fallbackDesignVersionId = fbVersionId;
      }
    ) || { componentDTOList: [], countComponentDTOList: [] };
    setResult(res);
    if (didFallback && fallbackDesignId && fallbackDesignVersionId) {
      setFallbackTarget({
        designId: fallbackDesignId,
        designVersionId: fallbackDesignVersionId,
      });
      setModalOpen(true);
    }
  }, [designComponentsList, designId, designVersionId]);

  const handleModalOk = useCallback(() => {
    setModalOpen(false);
    if (fallbackTarget) {
      navigate(
        `${redirectBase}/${projectId || ""}/${fallbackTarget.designId}/${
          fallbackTarget.designVersionId
        }?tab=design`
      );
    }
  }, [fallbackTarget, navigate, redirectBase, projectId]);

  const modal = (
    <SEConfirmModal
      opened={modalOpen}
      onClose={handleModalOk}
      onlyOk
      header={modalHeader}
      message={fallbackMessage}
    />
  );

  return { ...result, modal, showModal: modalOpen };
}

/**
 * Extracts the exact design version object from designWithVersionsDTOList using designId and designVersionId from route params
 */
export function useCurrentDesignVersion(designWithVersionsDTOList) {
  const { designId, designVersionId } = useAssessmentRouteParams();
  if (!Array.isArray(designWithVersionsDTOList)) return null;
  const designObj = designWithVersionsDTOList.find(
    (d) => String(d.designDTO?.designId) === String(designId)
  );
  if (!designObj || !Array.isArray(designObj.designVersionDTO)) return null;
  return (
    designObj.designVersionDTO.find(
      (v) => String(v.designVersionId) === String(designVersionId)
    ) || null
  );
}

// Hook to get grid/controller presence and version status for current design/version
export function useDesignVersionStatusAndComponents(
  designWithVersionsDTOList,
  designComponentsList
) {
  const { designId, designVersionId } = useAssessmentRouteParams();
  // Find design version object
  let versionStatus = null;
  if (Array.isArray(designWithVersionsDTOList)) {
    const designObj = designWithVersionsDTOList.find(
      (d) => String(d.designDTO?.designId) === String(designId)
    );
    if (designObj && Array.isArray(designObj.designVersionDTO)) {
      const versionObj = designObj.designVersionDTO.find(
        (v) => String(v.designVersionId) === String(designVersionId)
      );
      versionStatus = versionObj?.versionStatus || null;
    }
  }
  // Find grid/controller presence from designComponentsList
  let hasGrid = false;
  let hasController = false;
  let hasElectricalLoad = false;
  let hasThermalLoad = false;
  let hasOnlyElectricalLoad = false;
  let hasBothLoads = false;
  let hasNoLoad = false;
  let canViewSimulation = false;
  let componentId = null;
  if (Array.isArray(designComponentsList)) {
    const design = designComponentsList.find(
      (d) => String(d.designId) === String(designId)
    );
    let version;
    if (design && Array.isArray(design.designVersionComponents)) {
      version = design.designVersionComponents.find(
        (v) => String(v.designVersionId) === String(designVersionId)
      );
    }
    const countList = version?.countComponentDTOList || [];
    hasGrid = countList.some((c) => c.componentType === "Grid");
    hasController = countList.some((c) => c.componentType === "Controller");
    hasElectricalLoad = countList.some((c) => c.componentType === "ElectricalLoad");
    hasThermalLoad = countList.some((c) => c.componentType === "ThermalLoad");
    hasOnlyElectricalLoad = hasElectricalLoad && !hasThermalLoad;
    hasBothLoads = hasElectricalLoad && hasThermalLoad;
    hasNoLoad = !hasElectricalLoad && !hasThermalLoad;
    canViewSimulation = hasGrid && hasController;
    componentId = version?.componentDTOList?.find(c => c.componentType === "ThermalLoad")?.componentId || null;
  }
  canViewSimulation = canViewSimulation || versionStatus === "COMPLETED";
  return {
    hasGrid,
    hasController,
    hasElectricalLoad,
    hasThermalLoad,
    hasOnlyElectricalLoad,
    hasBothLoads,
    hasNoLoad,
    canViewSimulation,
    versionStatus,
    componentId,
  };
}

// Hook to check tab access and handle fallback modal/redirect if grid/controller missing
export function useTabAccessWithFallback(
  designWithVersionsDTOList,
  designComponentsList
) {
  const { designId, designVersionId } = useAssessmentRouteParams();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [blockedTab, setBlockedTab] = useState(null);
  // Optionally get setActiveState from atom if passed
  const [, setActiveState] = useAtom(activeTabAtom);
  // if (arguments.length > 2 && typeof arguments[2] === 'function') {
  //   setActiveState = arguments[2];
  // }
  // Check grid/controller and versionStatus
  let hasGrid = false;
  let hasController = false;
  let versionStatus = null;
  if (Array.isArray(designComponentsList)) {
    const design = designComponentsList.find(
      (d) => String(d.designId) === String(designId)
    );
    let version;
    if (design && Array.isArray(design.designVersionComponents)) {
      version = design.designVersionComponents.find(
        (v) => String(v.designVersionId) === String(designVersionId)
      );
    }
    const countList = version?.countComponentDTOList || [];
    hasGrid = countList.some((c) => c.componentType === "Grid");
    hasController = countList.some((c) => c.componentType === "Controller");
  }
  if (Array.isArray(designWithVersionsDTOList)) {
    const designObj = designWithVersionsDTOList.find(
      (d) => String(d.designDTO?.designId) === String(designId)
    );
    if (designObj && Array.isArray(designObj.designVersionDTO)) {
      const versionObj = designObj.designVersionDTO.find(
        (v) => String(v.designVersionId) === String(designVersionId)
      );
      versionStatus = versionObj?.versionStatus || null;
    }
  }
  const canViewSimulation =
    (hasGrid && hasController) || versionStatus === "COMPLETED";

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get("tab")?.toUpperCase();
    if (["SIMULATION", "RESULT"].includes(tab) && !canViewSimulation) {
      setBlockedTab(tab);
      setModalOpen(true);
    }
  }, [designId, designVersionId, canViewSimulation]);

  const handleModalOk = () => {
    setModalOpen(false);
    if (setActiveState) setActiveState("DESIGN");
    navigate("?tab=design");
  };

  const modal = (
    <SEConfirmModal
      opened={modalOpen}
      onClose={handleModalOk}
      onlyOk
      header="Design Component Missing"
      message={`The design must have both Grid and Controller components to access the ${blockedTab} tab.`}
    />
  );

  return { canViewSimulation, modal, showModal: modalOpen };
}

export const capitalizeFirstLetterOnly = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};


export const defaultKpiFactors = [
    { id: 1, name: "roi", min: 10, max: 999999999 },
    { id: 2, name: "payback", min: 0, max: 8 },
    {
      id: 3,
      name: "capitalExpenditure",
      min: 10,
      max: 999999999,
    },
    { id: 4, name: "irr", min: 10, max: 999999999 },
    // { id: 5, name: "savings", min: -50, max: -100 },
    // { id: 6, name: "netPresentCost", min: 50, max: 170 },
    // { id: 7, name: "lcoe", min: 50, max: 99 },
    // { id: 8, name: "co2Emission", min: 50, max: 99999 },
  ];

export function isAnyVersionCompleted(designWithVersionsDTOList) {
  if (!Array.isArray(designWithVersionsDTOList)) return false;
  for (const design of designWithVersionsDTOList) {
    const versions = Array.isArray(design?.designVersionDTO)
      ? design.designVersionDTO
      : [];
    if (versions.some((v) => String(v?.versionStatus) === "COMPLETED")) {
      return true;
    }
  }
  return false;
};

export const responsiveCol = { span: 12, sm: 6, md: 4, lg: 4, xl:3 }

export const formatRelativeTime = (value) => {
    if (!value) return "-";
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return "-";

    const diffMs = Date.now() - date.getTime();
    if (diffMs < 0) return "just now";

    const seconds = Math.floor(diffMs / 1000);
    if (seconds < 60) return `${seconds}s ago`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days < 30) return `${days}d ago`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months}mo ago`;
    const years = Math.floor(months / 12);
    return `${years}y ago`;
  };

export const isValidateDataForEnergyFlow = energyFlow => {
  if (!energyFlow || typeof energyFlow !== "object") {
    return false;
  }

  const values = [];

  const collect = obj => {
    if (!obj || typeof obj !== "object") {
      return;
    }
    for (const key of Object.keys(obj)) {
      // Ignore 'fromUnmetEnergy' per requirement
      if (key !== "fromUnmetEnergy") {
        const v = obj[key];
        if (v && typeof v === "object") {
          collect(v);
        } else {
          values.push(v);
        }
      }
    }
  };

  collect(energyFlow);
  if (values.length === 0) {
    return false;
  }

  for (const raw of values) {
    let n;
    if (typeof raw === "number") {
      n = raw;
    } else {
      n = Number(raw);
    }
    if (Number.isFinite(n) && n !== 0) {
      return true;
    }
  }
  return false;
};
